import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ActivityTypeResponseDto } from "../../../common/dtos/activity-type/activity-type.response";

@Injectable({
  providedIn : "root"
})
export abstract class ActivityTypeRepositoryInterface {

    public abstract getActivities(lang:string): Observable<ActivityTypeResponseDto>;

}